/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback } from 'react'
import './MessageOverviewStyle.css'
import useMessageOverview from './useMessageOverview'
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns'
import ChartComponent from '@components/common/Chart/ChartComponent.component'
import { marketingOverviewFilter } from '@dataTypes/marketing.type'

interface MessageOverviewProps {
  overviewDateFilter: marketingOverviewFilter
}

const MessageOverview: React.FC<MessageOverviewProps> = ({
  overviewDateFilter,
}) => {
  const hooks = useMessageOverview(overviewDateFilter)

  const tooltipTemplate = useCallback((args: any): JSX.Element => {
    return (
      <div className="mmc-custom-tooltip">
        <div className="tooltip-date">{args.x}</div>
        <div className="tooltip-series" style={{ color: args.color }}>
          <span>
            <span
              className="tooltip-series-marker"
              style={{
                backgroundColor: args.series.interior,
              }}
            />
            {args.series.properties.name}
          </span>
          <span>{args.y}</span>
        </div>
      </div>
    )
  }, [])

  return (
    <div className="mo-a-message-overview mo-board">
      <div className="mo-a-mo-header">
        <div className="mo-a-mo-header-left">
          <span className="mo-secondary-header">Message overview</span>
          <DropDownListComponent
            dataSource={hooks.campaignDropdownOptions}
            placeholder="Select campaign"
            value={hooks.selectedCampaign}
            change={(e) => hooks.setSelectedCampaign(e.value)}
          />
        </div>
      </div>
      <ChartComponent
        id="message-overview-line"
        data={hooks.messageOverview}
        height="290px"
        tooltipTemplate={tooltipTemplate}
        seriesWidth={2}
        xName="x"
        yName={['Sent', 'Delivered', 'Bounced', 'Unsubscribed']}
        yColor={['#24A1A3', '#185DD8', '#D8352A', '#B1D5FB']}
      />
    </div>
  )
}

export default MessageOverview
